import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/system-settings/")({
  head: () => ({ meta: [{ title: "系统设置 · imiker CRM" }] }),
});
